import Vue from 'vue';
import { i18n, loadDefaultLanguage } from '@v4/locale/async';
import DkBadge from '@v4/common/components/atoms/DkBadgeDST.vue';
import DkButton from '@v4/common/components/atoms/DkButton.vue';
import handlePagination from '@v4/archive/common/mixins/pagination';
import '@v4/common/utils/lazy-load';
import { pushGtagEvent } from '@v4/common/utils/google-analytics';

(async () => {
    await loadDefaultLanguage();

    if (document.getElementById('header')) {
        import(/* webpackChunkName: "header" */ '@v4/header').then(({ default: Header }) => Header());
    }

    const el = document.getElementById('archive-guide');

    if (!el) {
        return;
    }

    new Vue({
        el,
        name: 'GuidesPage',
        i18n,
        components: {
            DkBadge,
            DkButton,
            DkPagination: () => ({
                component: import(
                    /* webpackChunkName: "DkPagination-vue" */ '@v4/common/components/atoms/DkPagination.vue'
                ),
            }),
            DkGuideBadge: () => ({
                component: import(
                    /* webpackChunkName: "DkGuideBadge-vue" */ '@v4/common/components/atoms/DkGuideBadge.vue'
                ),
            }),
            DkNewsCard: () => ({
                component: import(
                    /* webpackChunkName: "DkNewsCard-vue" */ '@v4/common/components/organisms/DkNewsCard.vue'
                ),
            }),
        },
        mixins: [handlePagination],
        methods: {
            onGuideClick(id, title, category) {
                pushGtagEvent('select_content', null, null, {
                    // eslint-disable-next-line camelcase
                    content_type: category,
                    // eslint-disable-next-line camelcase
                    item_id: id,
                    // eslint-disable-next-line camelcase
                    title_guide: title,
                    // eslint-disable-next-line camelcase
                    page_source: window.location.href,
                });
            },
        },
    });
})();
